import { render, staticRenderFns } from "./compose.vue?vue&type=template&id=bf36ffee&scoped=true"
import script from "./compose.vue?vue&type=script&lang=js"
export * from "./compose.vue?vue&type=script&lang=js"
import style0 from "./compose.vue?vue&type=style&index=0&id=bf36ffee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf36ffee",
  null
  
)

export default component.exports